
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Admin', function (Parse) {

		/**
		 * Returns the number of Users registered on the platform
		 */
		this.countUsers = () => (new Parse.Query(Parse.User)).count();


		/**
		 * Return the total number of projects 
		 */
		this.countProjects = () => (new Parse.Query('Projects')).count();

		
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/admin.service.js